module.exports = __webpack_public_path__ + "static/media/ikebukuro_banner.5fcc846a.png";